import { orderBy } from "lodash";

import { type SalesPageMetric } from "@north-beam/nb-client-side";

const FREQUENTLY_USED_METRICS_IDS = [
  "spend",
  "Attributed Rev",
  "Rev__infinity",
  "Transactions",
  "visits",
  "ROAS",
  "CAC",
  "AOV",
  "cpm",
  "ctr",
  "ecpc",
];

export const getFrequentlyUsedMetrics = (metrics: SalesPageMetric[]) =>
  orderBy(
    metrics.filter((metric) => FREQUENTLY_USED_METRICS_IDS.includes(metric.id)),
    (metric) => FREQUENTLY_USED_METRICS_IDS.indexOf(metric.id),
  ) as SalesPageMetric[];

export const getExcludedFrequentlyUsedMetrics = (metrics: SalesPageMetric[]) =>
  metrics.filter((metric) => !FREQUENTLY_USED_METRICS_IDS.includes(metric.id));

// This API matches the fuzzy-search library
export class CustomMetricSearch {
  constructor(private options: { label: string; value: SalesPageMetric }[]) {
    this.options = options;
  }

  search(input: string) {
    const search = this.#makeSearchValue(input);
    const searchLength = search.length;

    if (searchLength === 0) {
      return this.options;
    }

    const result = this.options.filter((option) =>
      option.label.toLowerCase().includes(search),
    );

    return result.sort((a, b) =>
      this.#prioritizeResults(a.label, b.label, search),
    );
  }

  #makeSearchValue = (value: string) =>
    value.toLowerCase().replace("attributed", "").trim();

  #prioritizeResults = (a: string, _b: string, search: string) => {
    if (a.toLowerCase().startsWith(search)) {
      return -1;
    }
    return 1;
  };
}
